"use client";

import { CloudflareStreamVideo } from "@/components/shared/CloudflareStreamVideo";
import type { VideoBlock } from "@/features/editor/utils/content-blocks";

type VideoEmbedProps = Pick<VideoBlock, "url" | "title" | "platform">;

function is_gif_url(video_url: string): boolean {
  return /\.gif(\?.*)?$/i.test(video_url);
}

function is_video_file_url(video_url: string): boolean {
  return /\.(mp4|webm|mov)(\?.*)?$/i.test(video_url);
}

export function VideoEmbed({ url, title, platform = "cloudflare" }: VideoEmbedProps) {
  if (platform === "local") {
    if (!url) {
      return (
        <div className="h-[25vh] w-full lg:h-[40vh] md:h-[30vh] sm:h-[25vh] bg-gray-200 rounded-lg flex items-center justify-center">
          <p className="text-gray-500">No local media URL provided</p>
        </div>
      );
    }

    if (is_gif_url(url)) {
      return (
        <div className="w-full overflow-hidden rounded-lg">
          <img src={url} alt={title || "GIF"} className="w-full h-auto rounded-lg" />
        </div>
      );
    }

    if (is_video_file_url(url)) {
      return (
        <div className="w-full overflow-hidden rounded-lg">
          <video
            className="w-full h-auto rounded-lg"
            src={url}
            controls
            playsInline
            aria-label={title || "Video"}
          />
        </div>
      );
    }
  }

  // Default fallback is Cloudflare Stream.
  return (
    <div className="w-full overflow-hidden rounded-lg">
      <CloudflareStreamVideo uid={url} caption={title} />
    </div>
  );
}
